import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { useConfig } from '../../defaultConfig';
import type { Account } from '../../generated-types';
import type { SalaryDetailsResponse } from '../../hooks/useNextSalary';
import useTranslation, { format, formatJsx } from '../../hooks/useTranslation';
import { currencyFormatter } from '../shared/numberFormat';

import './SalaryInfoMobile.scss';

interface Props {
    salaryDetails: SalaryDetailsResponse;
    salaryAccount: Account;
}

const SalaryInfoMobile: React.FC<Props> = ({ salaryDetails: { amountLeft, daysLeft }, salaryAccount }) => {
    const translated = useTranslation();
    const { accountLink } = useConfig();
    return (
        <a href={`${accountLink?.url}?id=${salaryAccount.accountId.value}`} className="salary-info-mobile">
            <span className="typography-small bold">{salaryAccount.alias}</span>
            <span className="typography-small">{translated.salaryInfo.untilNextSalary}</span>
            <span className="salary-info-mobile__amount">
                <Icon type={IconTypes.SNAPCASH_24} />
                {currencyFormatter(amountLeft, 'NOK', 0)}
            </span>
            <span className="typography-small">
                {formatJsx(translated.salaryInfo.left, <strong>{format(translated.salaryInfo.days, daysLeft)}</strong>)}
            </span>
            <progress className="salary-info-mobile__progress" max={32} value={32 - daysLeft} />
        </a>
    );
};

export default SalaryInfoMobile;
